import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { SimpleBalancingGroupPortfolioCodeSetting } from '../custom';

class BalancingGroupPortfolioCodeSettingComponentCtrl
    implements ng.IController
{
    //If this is false, the component is for portfolio code
    public isBalancingGroup: boolean;
    public tsoRefId: number;
    //pass only valid enum values
    public setting: SimpleBalancingGroupPortfolioCodeSetting;
    public selection: SelectionPossibility;
    public selectionDescriptionLabel: string;
    //(default:0, use int numbers 1-12)
    public offset: number;
    //the number of cols you need for the description label (default:4, use int numbers 1-12)
    public numberCols: number;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private errorHandler: ErrorHandler
    ) {}

    $onInit() {
        if (angular.isUndefined(this.selectionDescriptionLabel)) {
            this.selectionDescriptionLabel = 'Long term';
        }
        if (angular.isUndefined(this.offset)) {
            this.offset = 0;
        }
        if (angular.isUndefined(this.numberCols)) {
            this.numberCols = 4;
        }
    }

    public saveSetting(
        setting: SimpleBalancingGroupPortfolioCodeSetting,
        selection: SelectionPossibility,
        oldValue: SelectionPossibility
    ) {
        const prefix: string = this.isBalancingGroup ? 'BG_' : 'PC_';
        this.TransmissionSystemOperator.saveBalancingGroupPortfolioCodeSetting(
            {
                id: this.tsoRefId,
                setting: prefix + setting
            },
            { value: selection },
            (res) => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            (err) => {
                this.selection = oldValue;
                this.errorHandler(err);
            }
        );
    }
}

angular.module('app').component('pkpBalancingGroupPortfolioCodeSetting', {
    controller: BalancingGroupPortfolioCodeSettingComponentCtrl,
    template:
        require('app/balancing-group-portfolio-code-setting/balancing-group-portfolio-code-setting.component.html'),
    bindings: {
        isBalancingGroup: '<',
        tsoRefId: '<',
        selection: '=',
        setting: '=',
        selectionDescriptionLabel: '<',
        offset: '<',
        numberCols: '<'
    }
});
